export default __webpack_public_path__ + "static/media/user-plus.b0a80907.svg";